function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LoyaltyEngagementSlider = function LoyaltyEngagementSlider(_ref) {
  var _ref$slides = _ref.slides,
    slides = _ref$slides === void 0 ? [] : _ref$slides,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay,
    _ref$autoplaySpeed = _ref.autoplaySpeed,
    autoplaySpeed = _ref$autoplaySpeed === void 0 ? 5000 : _ref$autoplaySpeed,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? true : _ref$loop,
    _ref$dots = _ref.dots,
    dots = _ref$dots === void 0 ? true : _ref$dots;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentIndex = _useState2[0],
    setCurrentIndex = _useState2[1];
  var timeoutRef = useRef(null);
  var touchStartX = useRef(0);
  var touchEndX = useRef(0);
  var length = slides.length;
  useEffect(function () {
    if (!autoplay || length <= 1) return undefined;
    timeoutRef.current = setTimeout(function () {
      setCurrentIndex(function (prev) {
        return prev === length - 1 ? 0 : prev + 1;
      });
    }, autoplaySpeed);
    return function () {
      return clearTimeout(timeoutRef.current);
    };
  }, [autoplay, autoplaySpeed, currentIndex, length]);
  if (!length) return null;
  var handlePrev = function handlePrev() {
    setCurrentIndex(function (prev) {
      return prev === 0 ? loop ? length - 1 : 0 : prev - 1;
    });
  };
  var handleNext = function handleNext() {
    setCurrentIndex(function (prev) {
      return prev === length - 1 ? loop ? 0 : length - 1 : prev + 1;
    });
  };
  var handleTouchStart = function handleTouchStart(e) {
    touchStartX.current = e.targetTouches[0].clientX;
  };
  var handleTouchMove = function handleTouchMove(e) {
    touchEndX.current = e.targetTouches[0].clientX;
  };
  var handleTouchEnd = function handleTouchEnd() {
    if (!touchStartX.current || !touchEndX.current) return;
    var diff = touchStartX.current - touchEndX.current;
    if (diff > 50) handleNext();
    if (diff < -50) handlePrev();
    touchStartX.current = 0;
    touchEndX.current = 0;
  };
  var getCardStyle = function getCardStyle(index) {
    var diff = (index - currentIndex + length) % length;
    var isNext = length === 2 ? index !== currentIndex : diff === 1;
    var isPrev = length === 2 ? false : diff === length - 1;
    if (diff === 0) {
      return {
        opacity: 1,
        transform: 'translate3d(-50%, 0, 0)',
        zIndex: 30
      };
    }
    if (isNext) {
      return {
        opacity: 1,
        transform: 'translate3d(calc(-50% + var(--how-to-earn-slide-offset)), var(--how-to-earn-slide-y-offset), 0)',
        zIndex: 20
      };
    }
    if (isPrev) {
      return {
        opacity: 1,
        transform: 'translate3d(calc(-50% - var(--how-to-earn-slide-offset)), var(--how-to-earn-slide-y-offset), 0)',
        zIndex: 20
      };
    }
    return {
      opacity: 0,
      transform: diff < length / 2 ? 'translate3d(calc(-50% + (var(--how-to-earn-slide-offset) * 2)), var(--how-to-earn-slide-y-offset), 0)' : 'translate3d(calc(-50% - (var(--how-to-earn-slide-offset) * 2)), var(--how-to-earn-slide-y-offset), 0)',
      zIndex: 0
    };
  };
  return /*#__PURE__*/_jsx("section", {
    className: "how-to-earn",
    children: /*#__PURE__*/_jsxs("div", {
      className: "how-to-earn__container !pt-6",
      onTouchStart: handleTouchStart,
      onTouchMove: handleTouchMove,
      onTouchEnd: handleTouchEnd,
      children: [/*#__PURE__*/_jsx("div", {
        className: "how-to-earn__viewport",
        children: slides.map(function (slide, index) {
          var isActive = currentIndex === index;
          return /*#__PURE__*/_jsx("div", {
            className: "how-to-earn__slide ".concat(isActive ? 'how-to-earn__slide--active' : 'how-to-earn__slide--side'),
            style: getCardStyle(index),
            onClick: function onClick() {
              return setCurrentIndex(index);
            },
            children: /*#__PURE__*/_jsx("div", {
              className: "how-to-earn__card",
              style: config !== null && config !== void 0 && config.primaryColor ? {
                borderColor: config.primaryColor
              } : undefined,
              children: /*#__PURE__*/_jsxs("div", {
                className: "how-to-earn__content",
                children: [/*#__PURE__*/_jsxs("div", {
                  className: "how-to-earn__icon-title",
                  children: [slide.icon && /*#__PURE__*/_jsx("div", {
                    className: "w-9 h-9 lg:w-12 lg:h-12",
                    children: typeof slide.icon === 'string' ? /*#__PURE__*/_jsx("img", {
                      src: slide.icon,
                      alt: slide.title,
                      className: "w-full h-full object-contain"
                    }) : slide.icon
                  }), /*#__PURE__*/_jsx("h3", {
                    className: "".concat((config === null || config === void 0 ? void 0 : config.fontTitle) || '', " text-[20px] lg:text-[28px] bg-gradient-to-r from-[#FDC977] to-[#FEEFD7] bg-clip-text text-transparent font-medium leading-none"),
                    children: slide.title
                  })]
                }), slide.description && /*#__PURE__*/_jsx("p", {
                  className: "".concat((config === null || config === void 0 ? void 0 : config.fontBody) || '', " max-w-[95%] text-[13px] leading-[1.3] lg:text-[18px] lg:leading-[1.5] mt-1 font-semibold pl-[56px] lg:pl-[60px]"),
                  children: slide.description
                })]
              })
            })
          }, "".concat(slide.title, "-").concat(index));
        })
      }), dots && length > 1 && /*#__PURE__*/_jsx("div", {
        className: "how-to-earn__dots",
        children: slides.map(function (_, index) {
          return /*#__PURE__*/_jsx("button", {
            type: "button",
            "aria-label": "Go to slide ".concat(index + 1),
            onClick: function onClick() {
              return setCurrentIndex(index);
            },
            className: currentIndex === index ? 'how-to-earn__dot how-to-earn__dot--active' : 'how-to-earn__dot'
          }, "dot-".concat(index));
        })
      })]
    })
  });
};
export default LoyaltyEngagementSlider;